import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WalletProvider } from './contexts/WalletContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { EscrowProvider } from './contexts/EscrowContext';
import HomePage from './components/HomePage';
import AdminPage from './components/AdminPage';
import DepositPage from './components/DepositPage';
import WithdrawPage from './components/WithdrawPage';
import './styles/themes.css';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <WalletProvider>
        <EscrowProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/manage" element={<AdminPage />} />
                <Route path="/deposit" element={<DepositPage />} />
                <Route path="/withdraw" element={<WithdrawPage />} />
              </Routes>
            </div>
          </Router>
        </EscrowProvider>
      </WalletProvider>
    </ThemeProvider>
  );
}

export default App;